/*
 * The arithmetic behind the passport's value list and its completeness: which
 * properties sit under which category, and which of them hold a value. Shared
 * by the list (ValuesPanel) and the editor that feeds the rail its counts.
 */

/** Above this many properties the value list opens as a preview. */
export const VALUES_PREVIEW_THRESHOLD = 5;

/** Rows the collapsed value list previews. */
export const VALUES_PREVIEW_ROWS = 3;

/** Whether a stored value counts as set: empty strings, lists and maps do not. */
export function isFilled(value) {
    if (value === undefined || value === null || value === '') return false;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object') return Object.keys(value).length > 0;
    return true;
}

/**
 * The property list in the ontology's order, cut into the groups its category
 * rows open: `[{ key, title, items: [{ property, index }] }]`. Properties
 * before the first category form a group with no header.
 */
export function groupProperties(properties) {
    const result = [];
    let group = { key: '__ungrouped', title: null, items: [] };
    (properties ?? []).forEach((property, index) => {
        if (property.type === 'category') {
            if (group.items.length || group.title) result.push(group);
            group = { key: property.id ?? `category-${index}`, title: property.value, items: [] };
            return;
        }
        group.items.push({ property, index });
    });
    if (group.items.length || group.title) result.push(group);
    return result;
}
